<template>
  <v-dialog
    content-class="dialog-fixed-top"
    :value="isVisible"
    @input="v => v || $dismiss()"
    max-width="1000"
  >
    <OLoading :value="isLoading" />

    <v-card v-if="!isLoading">
      <v-tabs v-model="activeTab" background-color="grey lighten-2">
        <v-tab ripple>Geral</v-tab>
        <v-tab ripple>JSON</v-tab>

        <v-tab-item :transition="false" :reverse-transition="false">
          <v-card flat>
            <v-card-text>
              <v-card tile flat color="grey lighten-2">
                <v-card-text>
                  <div class="h-row-wrap">
                    <div class="oderon-col-1 grey--text">Beep ID</div>
                    <div class="oderon-col-11">{{ row.id }}</div>

                    <div class="oderon-col-1 grey--text">Created at</div>
                    <div class="oderon-col-11">
                      {{ row.createdAt | brLongDateTime }}
                    </div>

                    <div class="oderon-col-1 grey--text">Source</div>
                    <div class="oderon-col-11">{{ row.source }}</div>

                    <div class="oderon-col-1 grey--text">Tags</div>
                    <div class="oderon-col-11">{{ row.tags }}</div>

                    <div class="oderon-col-12 py-2">
                      <v-divider />
                    </div>

                    <div class="oderon-col-1 grey--text">Subject</div>
                    <div class="oderon-col-11">{{ row.email.subject }}</div>

                    <div class="oderon-col-1 grey--text">From</div>
                    <div class="oderon-col-11">{{ row.email.from }}</div>

                    <div class="oderon-col-1 grey--text">To</div>
                    <div class="oderon-col-11">{{ allToEmails }}</div>
                  </div>
                </v-card-text>
              </v-card>
              <v-card tile flat>
                <v-card-text v-html="row.email.html" />
              </v-card>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item :transition="false" :reverse-transition="false">
          <v-card flat>
            <v-card-text>
              <pre>{{ row | prettyJson }}</pre>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-dialog>
</template>

<script>
import { Beep } from '../models'

export default {
  mixins: [require('oderon-vue/cpts/dialog-promise-mixin').default],
  components: {
    OLoading: require('oderon-vue/cpts/OLoading').default
  },
  props: ['value'],
  data() {
    return {
      isLoading: true,
      row: null,
      activeTab: 0
    }
  },
  computed: {
    allToEmails() {
      let l = this.row.emailReceipts || []
      return l.map(x => x.to).join(', ')
    }
  },
  methods: {
    open(id) {
      this.id = id
      this.$loading(() => this.fetchData())
      return this.$open()
    },

    async fetchData() {
      this.row = await Beep.findById(this.id)
    }
  },
  filters: {
    prettyJson(x) {
      return JSON.stringify(x, null, ' ')
    }
  }
}
</script>

<style></style>
